import React, { useEffect, useState } from 'react';
import api from '../api';
import EmptyState from './EmptyState';

// "Players" tab: league leaders by category (top 10 each), with photos.
// Players on your favourite team are highlighted. Before a season: last season's final leaders.
export default function Leaders({ sport, lang = 'en', favorite }) {
  const [data, setData] = useState(undefined);
  useEffect(() => {
    let alive = true;
    setData(undefined);
    api.fetchLeaders(sport).then((d) => { if (alive) setData(d || null); }).catch(() => { if (alive) setData(null); });
    return () => { alive = false; };
  }, [sport]);
  const fr = lang === 'fr';
  if (data === undefined) return <EmptyState icon="loading" title={fr ? 'Chargement des meneurs…' : 'Loading leaders…'} />;
  if (!data?.categories?.length) return <EmptyState icon="calendar" title={fr ? 'Meneurs indisponibles' : 'Leaders unavailable'} hint={fr ? 'Réessaie dans quelques minutes.' : 'Try again in a few minutes.'} />;
  return (
    <div className="st-wrap">
      <div className="st-top">
        <b className="ld-title">{fr ? 'Meneurs de la ligue' : 'League leaders'}</b>
        <span className="st-season">{data.final ? (fr ? `Saison ${data.season} · final` : `${data.season} season · final`) : (fr ? `Saison ${data.season}` : `${data.season} season`)}</span>
      </div>
      <div className="ld-grid">
        {data.categories.map((c) => (
          <div key={c.key} className="game-card ld-card">
            <div className="st-head"><b>{c.label[fr ? 'fr' : 'en']}</b></div>
            {c.leaders[0] && (
              <div className={`ld-top${c.leaders[0].team === favorite ? ' fav' : ''}`}>
                {c.leaders[0].photo ? <img className="ld-photo big" alt="" src={c.leaders[0].photo} onError={(e) => { e.currentTarget.style.visibility = 'hidden'; }} /> : <span className="ld-photo big" />}
                <span className="ld-who"><b>{c.leaders[0].name}</b><small>{c.leaders[0].team}{c.leaders[0].pos ? ` · ${c.leaders[0].pos}` : ''}</small></span>
                <b className="ld-value big">{c.leaders[0].value}</b>
              </div>
            )}
            <div className="ld-list">
              {c.leaders.slice(1).map((p) => (
                <div key={`${p.rank}-${p.name}`} className={`ld-row${p.team === favorite ? ' fav' : ''}`}>
                  <span className="ld-rank">{p.rank}</span>
                  {p.photo ? <img className="ld-photo" alt="" src={p.photo} onError={(e) => { e.currentTarget.style.visibility = 'hidden'; }} /> : <span className="ld-photo" />}
                  <span className="ld-who"><b>{p.name}</b><small>{p.team}</small></span>
                  <b className="ld-value">{p.value}</b>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
